import React, { useState, useEffect } from "react";
import { taxServiceClient } from "../../AxiosClient";
import { useTranslation } from "react-i18next";
import FormGroup from "@material-ui/core/FormGroup";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Trans } from "react-i18next";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import KpsTextField from "../../components/KpsTextField";
const useStyles = makeStyles((theme) => ({
  textField: {},
  buttons: {
    marginTop: theme.spacing(2),
  },
}));

function OrganizationEditor(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const [organizationId, setOrganizationId] = useState(props.organizationId);
  const [organization, setOrganization] = useState({});
  const [organizationName, setOrganizationName] = useState("");
  const [authenticationType, setAuthenticationType] = useState("");
  const [defaultTeamName, setDefaultTeamName] = useState("");
  const [systemAdmin, setSystemAdmin] = useState("");
  const teamIconSVG =
    "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z";
  const userIconSVG =
    "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z";

  const organizationSVG =
    "M18,15H16V17H18M18,11H16V13H18M20,19H12V17H14V15H12V13H14V11H12V9H20M10,7H8V5H10M10,11H8V9H10M10,15H8V13H10M10,19H8V17H10M6,7H4V5H6M6,11H4V9H6M6,15H4V13H6M6,19H4V17H6M12,7V3H2V21H22V7H12Z";

  useEffect(
    () => {
      setOrganizationId(props.organizationId);
      taxServiceClient
        .get(`/organization/${props.organizationId}`)
        .then((res) => {
          setOrganization(res.data);
          setOrganizationName(res.data.organizationName);
          setAuthenticationType(res.data.authenticationType);
          setSystemAdmin(
            res.data.systemManager !== null
              ? getSystemAdminName(res.data.systemManager)
              : ""
          );
          lookupTeam();
        });
    },
    [props.organizationId]
  );

  useEffect(
    () => {
      let updatedOrg = { ...organization };
      updatedOrg.organizationName = organizationName;
      setOrganization(updatedOrg);
    },
    [organizationName]
  );

  useEffect(
    () => {
      let updatedOrg = { ...organization };
      updatedOrg.authenticationType = authenticationType;
      setOrganization(updatedOrg);
    },
    [authenticationType]
  );

  const saveChanges = () => {
    taxServiceClient
      .patch(`/organization/${organizationId}`, organization)
      .then((res) => {
        props.updateOrganization && props.updateOrganization();
      });
  };
  const lookupTeam = () => {
    taxServiceClient
      .get(`/organization/${organizationId}/defaultteam/`)
      .then((res) => {
        setDefaultTeamName(res.data.teamName);
      });
  };
  const getSystemAdminName = (systemManager) => {
    return (
      systemManager.firstName +
      " " +
      systemManager.surname +
      " (" +
      systemManager.userLogin +
      ") "
    );
  };
  const getSystemAdmin = () => {
    return (
      <KpsTextField
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <svg height="24px" width="24px">
                <path fill={theme.palette.secondary.dark} d={userIconSVG} />
              </svg>
            </InputAdornment>
          ),
        }}
        id="SystemAdminUser"
        label={t("role_systemManager")}
        value={systemAdmin}
        className={classes.textField}
        margin="normal"
        disabled
      />
    );
  };
  const getTeam = () => {
    return (
      <KpsTextField
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <svg height="24px" width="24px">
                <path fill={theme.palette.secondary.dark} d={teamIconSVG} />
              </svg>
            </InputAdornment>
          ),
        }}
        id="DefaultTeamName"
        label={t("default_team")}
        value={defaultTeamName}
        className={classes.textField}
        margin="normal"
        disabled
      />
    );
  };

  return (
    <div>
      <FormGroup>
        <FormControl>
          <KpsTextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <svg height="24px" width="24px">
                    <path
                      fill={theme.palette.text.primary}
                      d={organizationSVG}
                    />
                  </svg>
                </InputAdornment>
              ),
            }}
            id="OrganizationName"
            label=""
            value={organizationName}
            className={classes.textField}
            margin="normal"
            variant="filled"
            onChange={(event) => setOrganizationName(event.target.value)}
          />
        </FormControl>
        <FormControl>{getSystemAdmin()}</FormControl>
        <FormControl>{getTeam()}</FormControl>
        <FormControl>
          <InputLabel htmlFor="authenticationType">
            <Trans i18nKey="organization_authentication_type" />
          </InputLabel>
          <Select
            value={authenticationType}
            onChange={(event) => setAuthenticationType(event.target.value)}
          >
            <MenuItem key="databaseAuthentication" value="database">
              <Trans i18nKey="organization_database_authentication" />
            </MenuItem>
            <MenuItem key="ldapAuthentication" value="ldap">
              <Trans i18nKey="organization_ldap_authentication" />
            </MenuItem>
            <MenuItem key="ldapDatabaseAuthentication" value="ldapdatabase">
              <Trans i18nKey="organization_ldapdatabase_authentication" />
            </MenuItem>
          </Select>
        </FormControl>
      </FormGroup>
      <div className={classes.buttons}>
        <ButtonGroup>
          <Button onClick={saveChanges}>
            <Trans i18nKey="save" />
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
}

export default OrganizationEditor;
